import React from 'react';
import PropTypes from 'prop-types';

class ClinicalImage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { originalUrl, type } = this.props;

    return (
      <div className="clinical-image">
        <div className="clinical-image__wrapper">
          <div className="clinical-image__image">
            <img src={originalUrl} alt={type} />
          </div>
        </div>
      </div>
    );
  }
}

ClinicalImage.defaultProps = {
  type: 'macroscopic'
};

ClinicalImage.propTypes = {
  type: PropTypes.string,
  originalUrl: PropTypes.string
};

export default ClinicalImage;
